import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Globe, Send } from 'lucide-react';
import { toast } from 'sonner';

export const JoinMovement = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      toast.success('Thank you for joining our movement! Check your email.');
      setEmail('');
    }
  };

  return (
    <section className="py-24 bg-gradient-to-b from-amber-50 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgb(217, 119, 6) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Join Our Movement
          </h2>
          <p className="font-playfair text-2xl md:text-3xl text-amber-800 italic mb-8">
            "Hope multiplies when shared."
          </p>
        </div>

        {/* Global Reach Map Placeholder */}
        <div className="bg-white rounded-2xl shadow-2xl p-12 mb-12">
          <div className="flex items-center justify-center mb-8">
            <Globe className="h-16 w-16 text-amber-600 animate-pulse" />
          </div>
          <h3 className="text-center font-playfair text-3xl font-bold text-gray-900 mb-4">
            Growing Global Impact
          </h3>
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <p className="text-4xl font-bold text-amber-600 mb-2">3</p>
              <p className="text-gray-600">Active Homes</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-amber-600 mb-2">52</p>
              <p className="text-gray-600">Lives Transformed</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-amber-600 mb-2">1,200+</p>
              <p className="text-gray-600">Community Supporters</p>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="bg-gradient-to-r from-amber-600 to-amber-700 rounded-2xl p-12 text-white text-center shadow-2xl">
          <h3 className="font-playfair text-3xl md:text-4xl font-bold mb-4">
            Stay Connected with Hope
          </h3>
          <p className="text-xl mb-8 text-amber-100">
            Receive stories, updates, and ways to make a difference directly in your inbox.
          </p>
          <form onSubmit={handleSubscribe} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-white text-gray-900 border-none py-6 text-lg"
                required
              />
              <Button
                type="submit"
                size="lg"
                className="bg-gray-900 hover:bg-black text-white px-8 py-6 transition-all duration-300 transform hover:scale-105"
              >
                <Send className="mr-2 h-5 w-5" />
                Subscribe
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};